/* eslint-disable */
import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Authorization from '../../Helpers/Authorization';
import ReactDOM from 'react-dom';

import {
  AdminNavLinks,
  NavLinks,
  UAT_NavLinks,
  QA_NavLinks,
  SuperAdminNavLinks,
  getImageSrc,
} from '../../Helpers/Constants';
import Env from '../../Helpers/env';

function SideNav() {
  const navigate = useNavigate();

  const [items, setItems] = React.useState(NavLinks);

  React.useEffect(() => {
    const userRole = Authorization.getAuthUserRole();

    if (userRole === 'SUPERADMIN') {
      setItems(SuperAdminNavLinks);
    } else if (userRole === 'ROOTADMIN') {
      setItems(AdminNavLinks);
    } else {
      setItems(
        Env.env.ENV === 'stage'
          ? QA_NavLinks
          : Env.env.ENV === 'pre-prod'
          ? UAT_NavLinks
          : NavLinks
      );
    }
  }, []);

  const onItemClick = path => {
    navigate(path);
  };

  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className="side-nav">
      {items.map(item => (
        <NavItem
          path={item.path}
          name={item.name}
          css={item.css}
          icon={item.icon}
          onItemClick={onItemClick}
          active={
            currentPath === item.path ||
            currentPath.startsWith(`${item.path}/`)
          }
          key={item.key}
        />
      ))}
    </div>
  );
}

function NavItem({ path, name, css, onItemClick, active }) {
  const [hoverName, setHoverName] = React.useState('');
  const [show, setShow] = React.useState(false);
  const [hoverTop, setHoverTop] = React.useState(0);

  return (
    <div className="d-flex wrapper-icon">
      <div
        className={`side-nav__item${active ? ' side-nav__item--active' : ''}`}
      >
        <Link
          to={path}
          className={css}
          onClick={() => onItemClick(path)}
        >
          <div
            className="navParent"
            onMouseLeave={() => setShow(false)}
            onMouseEnter={e => {
              const rect = e.target.getBoundingClientRect();
              setHoverTop(rect.top);
              setHoverName(name);
              setShow(true);
            }}
          >
            <img src={getImageSrc(name, active)} alt={name} />
          </div>
        </Link>
      </div>
      {show &&
        ReactDOM.createPortal(
          <div
            className="hover-bar"
            style={{ top: hoverTop, left: '8rem' }}
          >
            <p className="text-hover">{hoverName}</p>
          </div>,
          document.body
        )}
    </div>
  );
}

export default SideNav;
